<template>

  <!-- Customers -->
  <div id="story-mode-customers">

    <!-- Main Navigation -->
    <main-navigation
      :back="backNavigation"
      :next="nextNavigation"
    />
    <!-- Main Navigation -->

    <!-- Container -->
    <div class="container-1200">

      <!--<div v-if="$store.state.idea.storyMode.common.completedSteps.customersCompleted" class="completed-wrapper"></div>-->

      <!-- Content -->
      <div
        class="content"
        :class="{ 'position-relative': statusOfCompleted }"
      >
        <v-app>
          <!-- Page Header -->
          <header class="page-header">

            <!-- Dashboard Header -->
            <dashboard-header
              :class="{ 'stamp': statusOfCompleted }"
              :title="$t('steps.research.items.customers')"
              :guide-visible="guideVisible"
              :guide-visible-first-time="guideVisibleFirstTime"
              :completed-step-name="'customersCompleted'"
              hide-quick-tour-button
              @toggle-guide="onGuideExampleVisible"
              @open-comp-dialog="openedDialogProcessCompleted"
              @open-info="openInfo"
              @open-ai-buddy-drawer="aiBuddyDrawerVisible = true"
            />
            <!-- /Dashboard Header -->

            <!-- Divider -->
            <hr>
          <!-- /Divider -->

          </header>
          <!-- /Page Header -->

          <!-- Info Guide Expand Panel -->
          <info-guide
            v-if="guideVisibleFirstTime"
            class="mb-5"
            type="customersExamples"
            visible
            @click="guideVisibleFirstTime = !guideVisibleFirstTime"
          />
          <!-- Info Guide Expand Panel -->

          <!-- Ai Buddy Drawer -->
          <ai-buddy-drawer
            :visible="aiBuddyDrawerVisible"
            section-name="Customers"
            help-me-write
            type="customers"
            @close="aiBuddyDrawerVisible = false"
          />
        <!-- /Ai Buddy Drawer -->
        </v-app>

        <!-- Business plan additional info -->
        <business-plan-additional-info
          completed-step-name="customersCompleted"
          section-name="Customers"
          show-ai-buddy
          :loading-state="aiBuddyLoader"
          @ai-buddy-open="aiBuddyDrawerVisible = true"
        />
        <!-- /Business plan additional info -->

        <!-- Height Holder For Sticky Header -->
        <div class="height-holder d-none d-md-block" />
        <!-- /Height Holder For Sticky Header -->

        <v-app>
          <!-- Header -->
          <business-guide-header>
            <template #left>
              <h2 class="mt-md-6">
                {{ $t('pages.businessGuide.customers.targetCustomers') }}
              </h2>
              <p class="text-lead">
                {{ $t('pages.businessGuide.customers.createProfilesOfYourCustomers') }}
              </p>
            </template>
            <template #right>
              <ai-template-blinking-animation v-if="aiTemplateLoader" />
              <erase-icon-button
                v-if="removeButtonVisible"
                @click="onEraseFromTemplate"
              />
              <business-guide-search
                v-if="!isCustomersEmpty"
                v-model="searchValue"
                class="mx-1"
              />
              <!-- View Switcher -->
              <view-switcher
                v-if="isCustomersEmpty === false"
                :active-view="$store.state.itemsView.customersView"
                @activate-view="onActivateView"
              />
              <!-- /View Switcher -->
            </template>
          </business-guide-header>
          <!-- /Header -->
        </v-app>

        <!-- Customers -->
        <div class="customers customers-filled">

          <!-- Grid Wrapper -->
          <div class="grid-wrapper" :class="{ 'active': $store.state.itemsView.customersView === 'grid' }">
            <el-row :gutter="20">
              <!-- Completed Overlay -->
              <completed-overlay
                v-if="hasNotAccess"
                @click="checkCustomersCard"
              />
              <!-- /Completed Overlay -->

              <!-- Empty state grid -->
              <div
                v-if="isCustomersEmpty"
                class="d-flex flex-wrap"
              >
                <el-col :md="8" :xl="6" class="d-flex mb-3">
                  <add-new-card
                    :title="$tc('addTargetCustomer')"
                    :disabled="hasNotAccess || aiTemplateLoader"
                    @click="dialogAddCustomerVisible = true"
                  />
                </el-col>

                <!-- Placeholder 1 -->
                <el-col v-if="$breakpoint.mdAndUp" :md="8" :xl="6" class="d-flex mb-3">
                  <div class="placeholder-card xxlarge w-100">
                    <div class="w-100">
                      <div class="avatar-placeholder blue" />
                      <div class="stripe-medium" />
                      <div class="stripe-xsmall" />
                      <div class="stripe-small" />
                      <div class="stripe-large" />
                      <div class="stripe-large" />
                      <div class="stripe-large" />
                      <div class="placeholder-list">
                        <ul>
                          <li />
                          <li />
                          <li />
                        </ul>
                      </div>
                      <div class="stripe-large" />
                    </div>
                  </div>
                </el-col>
                <!-- /Placeholder 1 -->

                <!-- Placeholder 2 -->
                <el-col v-if="$breakpoint.mdAndUp" :md="8" :xl="6" class="d-flex mb-3">
                  <div class="placeholder-card xxlarge w-100">
                    <div class="w-100">
                      <div class="avatar-placeholder blue" />
                      <div class="stripe-medium" />
                      <div class="stripe-xsmall" />
                      <div class="stripe-small" />
                      <div class="stripe-large" />
                      <div class="stripe-large" />
                      <div class="stripe-large" />
                      <div class="placeholder-list">
                        <ul>
                          <li />
                          <li />
                          <li />
                        </ul>
                      </div>
                      <div class="stripe-large" />
                    </div>
                  </div>
                </el-col>
                <!-- /Placeholder 2 -->
              </div>
              <!-- /Empty state grid -->

              <!-- Tutorial Tooltip TODO - Currently disabled in if directive -->
              <tutorial-tooltip
                v-if="$store.state.user.tutorial.customersCompleted === false && 1 === 2"
                :title="$t('pages.businessGuide.customers.addCustomersYouWant')"
                :text="$t('pages.businessGuide.thisIsStarOfYourShow')"
                :tutorial-name="'customersCompleted'"
              />
              <!-- /Tutorial Tooltip -->

              <!-- Grid Items -->
              <template v-if="!isCustomersEmpty">
                <ib-draggable
                  class="d-flex flex-wrap"
                  :list="customersToShowGrid"
                  :options="{disabled: hasNotAccess}"
                  @change="onChangeCustomersOrder"
                  @start="onStartCustomersOrder"
                >
                  <template #header>
                    <el-col
                      :md="8"
                      :xl="6"
                      class="d-flex mb-3"
                    >
                      <add-new-card
                        :min-height="$breakpoint.mdAndUp ? '579px' : '164px'"
                        :title="$tc('addTargetCustomer')"
                        :disabled="hasNotAccess || aiTemplateLoader"
                        @click="dialogAddCustomerVisible = true"
                      />
                    </el-col>
                  </template>

                  <el-col
                    v-for="customer in customersToShowGrid"
                    :key="customer.id"
                    class="draggable"
                    :md="8"
                    :xl="6"
                  >
                    <div
                      class="customer-card cursor-move mb-3"
                      @click="checkCustomersCard(customer)"
                    >
                      <!-- Card Top -->
                      <div
                        class="card-top"
                        :class="{ 'default': !customer.image }"
                        :style="cardImageBySize(customer.image, 'medium')"
                      >

                        <!-- Actions Dropdown -->
                        <actions-dropdown
                          v-if="canEdit && !statusOfCompleted"
                          ref="actionsDropdown"
                          :entity="customer"
                          @edit="onEditCustomer"
                          @copy="onCopyCustomer"
                          @delete="onDeleteCustomer"
                        />
                        <!-- /Actions Dropdown -->

                      </div>
                      <!-- /Card Top -->

                      <!-- Card Bottom -->
                      <div class="card-bottom">

                        <!-- Name -->
                        <h3>{{ customer.name }}</h3>
                        <!-- /Name -->

                        <!-- Description -->
                        <!--                        <el-popover-->
                        <!--                          v-if="customer.description"-->
                        <!--                          :title="customer.description"-->
                        <!--                          popper-class="tooltip-desc"-->
                        <!--                          placement="top"-->
                        <!--                          trigger="click"-->
                        <!--                        >-->
                        <!--                          <p slot="reference" class="desc pre-formatted text-left ml-2 mr-2">-->
                        <!--                            {{ customer.description }}-->
                        <!--                          </p>-->
                        <!--                        </el-popover>-->

                        <p class="desc pre-formatted text-left ml-2 mr-2">
                          {{ customer.description }}
                        </p>
                        <!-- /Description -->

                        <!-- Pain Points TODO - REFACTOR -->
                        <ul class="pain-points">
                          <li v-for="point in customer.painPoints" :key="point.id">
                            <span slot="suffix">
                              <svg xmlns="http://www.w3.org/2000/svg" width="438.533" height="438.533" viewBox="0 0 438.533 438.533" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064zm-21.699 181.01c-9.709 22.556-22.696 41.97-38.969 58.245-16.271 16.269-35.689 29.26-58.245 38.965-22.555 9.712-46.202 14.564-70.946 14.564s-48.391-4.853-70.948-14.564c-22.554-9.705-41.971-22.696-58.245-38.965-16.269-16.275-29.259-35.687-38.97-58.245-9.707-22.552-14.562-46.206-14.562-70.946 0-24.744 4.854-48.391 14.562-70.948 9.707-22.554 22.697-41.968 38.97-58.245 16.274-16.269 35.691-29.26 58.245-38.97 22.554-9.704 46.205-14.558 70.948-14.558 24.74 0 48.395 4.851 70.946 14.558 22.556 9.707 41.97 22.698 58.245 38.97 16.272 16.274 29.26 35.688 38.969 58.245 9.709 22.554 14.564 46.201 14.564 70.948.004 24.744-4.855 48.397-14.564 70.946z"/><path d="M284.368 258.668c-19.219-14.086-40.926-21.129-65.095-21.129-24.172 0-45.871 7.039-65.096 21.129-19.224 14.085-32.358 32.641-39.397 55.671-1.521 4.757-1.143 9.381 1.141 13.847 2.286 4.469 5.898 7.467 10.85 8.993 4.758 1.526 9.373 1.143 13.846-1.144 4.471-2.285 7.467-5.899 8.991-10.848 4.759-15.235 13.562-27.556 26.409-36.979 12.847-9.418 27.263-14.127 43.252-14.127 15.987 0 30.412 4.712 43.251 14.127 12.854 9.424 21.655 21.744 26.412 36.979 1.52 4.948 4.564 8.562 9.134 10.848 4.568 2.286 9.236 2.67 13.989 1.144 4.761-1.526 8.278-4.524 10.564-8.993 2.286-4.466 2.669-9.09 1.14-13.847-7.03-23.027-20.168-41.589-39.391-55.671zM146.181 182.725c10.085 0 18.699-3.576 25.837-10.709 7.139-7.135 10.708-15.749 10.708-25.837 0-10.089-3.569-18.699-10.708-25.837s-15.752-10.709-25.837-10.709c-10.088 0-18.702 3.571-25.84 10.709-7.135 7.139-10.707 15.749-10.707 25.837s3.568 18.702 10.707 25.837c7.141 7.136 15.752 10.709 25.84 10.709zM292.359 109.631c-10.089 0-18.706 3.571-25.845 10.709-7.132 7.139-10.708 15.749-10.708 25.837s3.576 18.702 10.708 25.837c7.139 7.137 15.756 10.709 25.845 10.709 10.081 0 18.698-3.576 25.837-10.709 7.139-7.135 10.708-15.749 10.708-25.837 0-10.089-3.569-18.699-10.708-25.837s-15.756-10.709-25.837-10.709z"/></svg>
                            </span>
                            <!--                            <ib-tooltip-->
                            <!--                              :content="point.value"-->
                            <!--                              popper-class="tooltip-points"-->
                            <!--                              placement="right"-->
                            <!--                            >-->
                            <p>{{ point.value }}</p>
                            <!--                            </ib-tooltip>-->
                          </li>
                          <!--<li>
                              <span v-if="customer.painPoints.length > 1 && customer.painPoints[1].value" slot="suffix"><svg xmlns="http://www.w3.org/2000/svg" width="438.533" height="438.533" viewBox="0 0 438.533 438.533" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064zm-21.699 181.01c-9.709 22.556-22.696 41.97-38.969 58.245-16.271 16.269-35.689 29.26-58.245 38.965-22.555 9.712-46.202 14.564-70.946 14.564s-48.391-4.853-70.948-14.564c-22.554-9.705-41.971-22.696-58.245-38.965-16.269-16.275-29.259-35.687-38.97-58.245-9.707-22.552-14.562-46.206-14.562-70.946 0-24.744 4.854-48.391 14.562-70.948 9.707-22.554 22.697-41.968 38.97-58.245 16.274-16.269 35.691-29.26 58.245-38.97 22.554-9.704 46.205-14.558 70.948-14.558 24.74 0 48.395 4.851 70.946 14.558 22.556 9.707 41.97 22.698 58.245 38.97 16.272 16.274 29.26 35.688 38.969 58.245 9.709 22.554 14.564 46.201 14.564 70.948.004 24.744-4.855 48.397-14.564 70.946z"/><path d="M284.368 258.668c-19.219-14.086-40.926-21.129-65.095-21.129-24.172 0-45.871 7.039-65.096 21.129-19.224 14.085-32.358 32.641-39.397 55.671-1.521 4.757-1.143 9.381 1.141 13.847 2.286 4.469 5.898 7.467 10.85 8.993 4.758 1.526 9.373 1.143 13.846-1.144 4.471-2.285 7.467-5.899 8.991-10.848 4.759-15.235 13.562-27.556 26.409-36.979 12.847-9.418 27.263-14.127 43.252-14.127 15.987 0 30.412 4.712 43.251 14.127 12.854 9.424 21.655 21.744 26.412 36.979 1.52 4.948 4.564 8.562 9.134 10.848 4.568 2.286 9.236 2.67 13.989 1.144 4.761-1.526 8.278-4.524 10.564-8.993 2.286-4.466 2.669-9.09 1.14-13.847-7.03-23.027-20.168-41.589-39.391-55.671zM146.181 182.725c10.085 0 18.699-3.576 25.837-10.709 7.139-7.135 10.708-15.749 10.708-25.837 0-10.089-3.569-18.699-10.708-25.837s-15.752-10.709-25.837-10.709c-10.088 0-18.702 3.571-25.84 10.709-7.135 7.139-10.707 15.749-10.707 25.837s3.568 18.702 10.707 25.837c7.141 7.136 15.752 10.709 25.84 10.709zM292.359 109.631c-10.089 0-18.706 3.571-25.845 10.709-7.132 7.139-10.708 15.749-10.708 25.837s3.576 18.702 10.708 25.837c7.139 7.137 15.756 10.709 25.845 10.709 10.081 0 18.698-3.576 25.837-10.709 7.139-7.135 10.708-15.749 10.708-25.837 0-10.089-3.569-18.699-10.708-25.837s-15.756-10.709-25.837-10.709z"/></svg> </span>
                              <p>{{ customer.painPoints.length > 1 ? customer.painPoints[1].value : '' }}</p>
                              <p class="italic"
                                 :class="{'italic-placeholder': customer.painPoints.length > 1 && customer.painPoints[1].value === ''}"
                              />
                            </li>
                            <li>
                              <span v-if="customer.painPoints.length > 2 && customer.painPoints[2].value" slot="suffix"><svg xmlns="http://www.w3.org/2000/svg" width="438.533" height="438.533" viewBox="0 0 438.533 438.533" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064zm-21.699 181.01c-9.709 22.556-22.696 41.97-38.969 58.245-16.271 16.269-35.689 29.26-58.245 38.965-22.555 9.712-46.202 14.564-70.946 14.564s-48.391-4.853-70.948-14.564c-22.554-9.705-41.971-22.696-58.245-38.965-16.269-16.275-29.259-35.687-38.97-58.245-9.707-22.552-14.562-46.206-14.562-70.946 0-24.744 4.854-48.391 14.562-70.948 9.707-22.554 22.697-41.968 38.97-58.245 16.274-16.269 35.691-29.26 58.245-38.97 22.554-9.704 46.205-14.558 70.948-14.558 24.74 0 48.395 4.851 70.946 14.558 22.556 9.707 41.97 22.698 58.245 38.97 16.272 16.274 29.26 35.688 38.969 58.245 9.709 22.554 14.564 46.201 14.564 70.948.004 24.744-4.855 48.397-14.564 70.946z"/><path d="M284.368 258.668c-19.219-14.086-40.926-21.129-65.095-21.129-24.172 0-45.871 7.039-65.096 21.129-19.224 14.085-32.358 32.641-39.397 55.671-1.521 4.757-1.143 9.381 1.141 13.847 2.286 4.469 5.898 7.467 10.85 8.993 4.758 1.526 9.373 1.143 13.846-1.144 4.471-2.285 7.467-5.899 8.991-10.848 4.759-15.235 13.562-27.556 26.409-36.979 12.847-9.418 27.263-14.127 43.252-14.127 15.987 0 30.412 4.712 43.251 14.127 12.854 9.424 21.655 21.744 26.412 36.979 1.52 4.948 4.564 8.562 9.134 10.848 4.568 2.286 9.236 2.67 13.989 1.144 4.761-1.526 8.278-4.524 10.564-8.993 2.286-4.466 2.669-9.09 1.14-13.847-7.03-23.027-20.168-41.589-39.391-55.671zM146.181 182.725c10.085 0 18.699-3.576 25.837-10.709 7.139-7.135 10.708-15.749 10.708-25.837 0-10.089-3.569-18.699-10.708-25.837s-15.752-10.709-25.837-10.709c-10.088 0-18.702 3.571-25.84 10.709-7.135 7.139-10.707 15.749-10.707 25.837s3.568 18.702 10.707 25.837c7.141 7.136 15.752 10.709 25.84 10.709zM292.359 109.631c-10.089 0-18.706 3.571-25.845 10.709-7.132 7.139-10.708 15.749-10.708 25.837s3.576 18.702 10.708 25.837c7.139 7.137 15.756 10.709 25.845 10.709 10.081 0 18.698-3.576 25.837-10.709 7.139-7.135 10.708-15.749 10.708-25.837 0-10.089-3.569-18.699-10.708-25.837s-15.756-10.709-25.837-10.709z"/></svg> </span>
                              <p>{{ customer.painPoints.length > 2 ? customer.painPoints[2].value : '' }}</p>
                              <p class="italic"
                                 :class="{'italic-placeholder': customer.painPoints.length > 2 && customer.painPoints[2].value === ''}"
                              />
                            </li>-->
                        </ul>
                        <!-- /Pain Points -->

                        <!-- Grading List -->
                        <ul class="grading-list">
                          <li>
                            <p>{{ $t('pages.businessGuide.customers.addDialog.attributes.segmentSize') }}</p>
                            <p class="bold">
                              {{ customer.segmentSize }}<span class="regular">/5</span>
                            </p>
                          </li>
                          <li>
                            <p>{{ $t('pages.businessGuide.customers.addDialog.attributes.willingness') }}</p>
                            <p class="bold">
                              {{ customer.willingnessToPay }}<span class="regular">/5</span>
                            </p>
                          </li>
                          <li>
                            <p>{{ $t('pages.businessGuide.customers.addDialog.attributes.accessibility') }}</p>
                            <p class="bold">
                              {{ customer.accessibility }}<span class="regular">/5</span>
                            </p>
                          </li>
                        </ul>
                        <!-- /Grading List -->

                        <!-- Priority -->
                        <div
                          class="priority"
                          :class="[getCustomerLevel(customer) === $t('medium') ? 'medium': '' || getCustomerLevel(customer) === $t('low') ? 'low': '']"
                        >
                          <p>{{ $t('priority') }}</p>
                          <p class="title">
                            {{ getCustomerLevel(customer) }}
                          </p>
                        </div>
                        <!-- /Priority -->
                      </div>
                      <!-- /Card Bottom -->
                    </div>
                  </el-col>
                </ib-draggable>
              </template>
              <!-- /Grid Items -->
            </el-row>

            <!-- Show All -->
            <el-row v-if="$store.state.idea.storyMode.research.customers.customers.length > 3">
              <el-col>
                <show-all-toggle
                  :show="showAllCustomersGrid"
                  @click="showAllCustomersGrid = !showAllCustomersGrid"
                />
              </el-col>
            </el-row>
            <!-- /Show All -->
          </div>
          <!-- /Grid Wrapper -->

          <!-- List Wrapper -->
          <div class="list-wrapper" :class="{ 'active': $store.state.itemsView.customersView === 'list' }">
            <el-row :gutter="20">
              <!-- Completed Overlay -->
              <completed-overlay
                v-if="hasNotAccess"
                @click="checkCustomersCard"
              />
              <!-- /Completed Overlay -->

              <!-- List Items -->
              <ib-draggable
                class="d-flex flex-wrap"
                :list="customersToShowGrid"
                :options="{disabled: hasNotAccess}"
                @change="onChangeCustomersOrder"
                @start="onStartCustomersOrder"
              >
                <template #header>
                  <!-- New Customer -->
                  <el-col :md="12" class="d-flex mb-2">
                    <add-new-card
                      class="py-2 py-md-0"
                      min-height="54px"
                      :title="$tc('addTargetCustomer')"
                      :disabled="hasNotAccess || aiTemplateLoader"
                      horizontal
                      @click="dialogAddCustomerVisible = true"
                    />
                  </el-col>
                </template>
                <!-- /New Customer -->
                <el-col
                  v-for="customer in customersToShowList"
                  :key="customer.id"
                  :md="12"
                  class="draggable mb-2"
                >
                  <div
                    class="customer-card cursor-move"
                    @click="checkCustomersCard(customer)"
                  >

                    <!-- Card Top -->
                    <div class="card-top">

                      <!-- Card Image & Name -->
                      <div class="flex-inner">

                        <!-- Card Image -->
                        <div>
                          <div
                            class="card-image-round"
                            :class="{ 'default': !customer.image }"
                            :style="cardImageBySize(customer.image, 'small')"
                          />
                        </div>
                        <!-- /Card Image -->

                        <!-- Name -->
                        <div>
                          <h3>{{ customer.name }}</h3>
                        </div>
                        <!-- /Name -->

                      </div>
                      <!-- /Card Image & Name -->

                      <!-- Priority & Actions Dropdown -->
                      <div class="flex-inner">

                        <!-- Priority -->
                        <div
                          class="priority"
                          :class="[getCustomerLevel(customer) === $t('medium') ? 'medium': '' || getCustomerLevel(customer) === $t('low') ? 'low': '']"
                        >
                          <p class="title">
                            {{ getCustomerLevel(customer) }} <span>{{ $t('priority') }}</span>
                          </p>
                        </div>
                        <!-- /Priority -->

                        <!-- Actions Dropdown -->
                        <actions-dropdown
                          v-if="canEdit && !statusOfCompleted"
                          ref="actionsDropdown"
                          :entity="customer"
                          @edit="onEditCustomer"
                          @copy="onCopyCustomer"
                          @delete="onDeleteCustomer"
                        />
                        <!-- /Actions Dropdown -->

                      </div>
                      <!-- /Priority & Actions Dropdown -->

                    </div>
                    <!-- /Card Top -->

                  </div>
                </el-col>
              </ib-draggable>
              <!-- /List Items -->
            </el-row>
            <!-- Show All -->
            <el-row v-if="$store.state.idea.storyMode.research.customers.customers.length > 7">
              <el-col>
                <show-all-toggle
                  :show="showAllCustomersList"
                  @click="showAllCustomersList = !showAllCustomersList"
                />
              </el-col>
            </el-row>
            <!-- /Show All -->
          </div>
          <!-- /List Wrapper -->

        </div>
        <!-- /Customers -->

      </div>
      <!-- /Content -->

      <!-- Add More Details -->
      <add-more-details
        :category="'research'"
        :step="'customers'"
        :concept-name="'customersMoreDetails'"
        :completed-step-name="'customersCompleted'"
      />
      <!-- /Add More Details -->

    </div>
    <!-- /Container -->

    <!-- Main Bottom Bar -->
    <main-bottom-bar
      :back="backNavigation"
      :next="nextNavigation"
      :completed-step-name="'customersCompleted'"
      :step-filled="$store.state.idea.storyMode.research.customers.customers.length > 0"
      @complete-step="onCompleteStep"
    />
    <!-- /Main Bottom Bar -->

    <!-- Info Guide Drawer -->
    <info-guide-drawer
      type="customersExamples"
      :visible="guideVisible"
      @close="guideVisible = false"
    />
    <!-- /Info Guide Drawer -->

    <!-- Dialog Add Customer -->
    <dialog-add-customer
      :dialog-add-customer-visible="dialogAddCustomerVisible"
      :customer-action="customerAction"
      @close-dialog-add-customer="onCloseDialogAddCustomer"
    />
    <!-- /Dialog Add Customer -->

    <!-- Dialog Process Completed -->
    <dialog-process-completed
      :dialog-process-completed-visible="dialogProcessCompletedVisible"
      @close-dialog-process-completed="onCloseDialogProcessCompleted"
    />
    <!-- /Dialog Process Completed -->

    <!-- Dialog Remove Examples -->
    <dialog-remove-examples
      :visible="dialogRemoveExamplesVisible"
      :loading="removeExamplesLoading"
      @no="dialogRemoveExamplesVisible = false"
      @yes="deleteExamples"
    />
    <!-- /Dialog Remove Examples -->

  </div>
  <!-- /Customers -->

</template>

<script>
import ActionsDropdown from '@/views/Home/StoryMode/Components/ActionsDropdown'
import AddMoreDetails from '@/views/Home/StoryMode/Components/AddMoreDetails'
import AddNewCard from '@/components/_v2/AddNewCard'
import AiBuddyDrawer from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue'
import BusinessGuideHeader from '@/components/_v2/Common/BusinessGuideHeader'
import BusinessGuideSearch from '@/views/Home/Components/BusinessGuideSearch.vue'
import BusinessPlanAdditionalInfo from '@/views/Home/StoryMode/Components/BusinessPlanAdditionalInfo.vue'
import CompletedOverlay from '@/views/Home/StoryMode/Components/CompletedOverlay'
import DashboardHeader from '@/views/Home/StoryMode/Components/DashboardHeader'
import DialogAddCustomer from './Dialogs/DialogAddCustomer'
import DialogProcessCompleted from '@/views/Home/StoryMode/Components/Dialogs/DialogProcessCompleted'
import DialogRemoveExamples from '@/views/Home/StoryMode/Components/DialogRemoveExamples'
import EraseIconButton from '@/components/_v2/EraseIconButton'
import MainBottomBar from '@/views/Home/StoryMode/Components/MainBottomBar/MainBottomBar'
import MainNavigation from '@/views/Home/StoryMode/Components/MainNavigation/MainNavigation'
import MixinAiTemplate from '@/mixins/aiTemplate'
import MixinDeleteIdeaExamples from '@/mixins/deleteIdeaExamples'
import MixinEraseTemplate from '@/mixins/eraseTemplate'
import MixinGuide from '@/mixins/guide'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import MixinProcessCompleted from '@/mixins/processCompleted'
import ShowAllToggle from '@/views/Home/StoryMode/Components/ShowAllToggle'
import TutorialTooltip from '@/views/Home/Components/TutorialTooltip'
import ViewSwitcher from '@/components/_v2/ViewSwitcher'

import { mapActions, mapGetters } from 'vuex'
import { getImageBySize } from '@/helpers/imageSizeHelper'

import AiTemplateBlinkingAnimation from '@/views/Home/StoryMode/Components/AiTemplateBlinkingAnimation.vue'
import InfoGuide from '@/views/Home/StoryMode/Components/Example/InfoGuide.vue'
import InfoGuideDrawer from '@/views/Home/StoryMode/Components/Example/InfoGuideDrawer.vue'

export default {
  name: 'Customers',

  components: {
    AiTemplateBlinkingAnimation,
    InfoGuide,
    AiBuddyDrawer,
    InfoGuideDrawer,
    BusinessPlanAdditionalInfo,
    BusinessGuideSearch,
    AddNewCard,
    ActionsDropdown,
    AddMoreDetails,
    BusinessGuideHeader,
    CompletedOverlay,
    DashboardHeader,
    DialogAddCustomer,
    DialogProcessCompleted,
    DialogRemoveExamples,
    EraseIconButton,
    MainBottomBar,
    MainNavigation,
    ShowAllToggle,
    TutorialTooltip,
    ViewSwitcher
  },

  mixins: [
    MixinProcessCompleted,
    MixinGuide,
    MixinDeleteIdeaExamples,
    MixinIdeaRoles,
    MixinEraseTemplate,
    MixinAiTemplate
  ],

  data () {
    return {
      aiBuddyDrawerVisible: false,
      searchValue: '',
      removeExamplesLoading: false,
      dialogRemoveExamplesVisible: false,
      dialogAddCustomerVisible: false,
      guideVisible: false,
      customerAction: null,
      showAllCustomersGrid: false,
      showAllCustomersList: false,
      dialogProcessCompletedVisible: false,
      examples: []
    }
  },

  computed: {
    ...mapGetters('idea', {
      customers: 'getCustomers',
      getStepIsCompleted: 'getStepIsCompleted',
      getHasItemsFromTemplate: 'getHasItemsFromTemplate'
    }),

    statusOfCompleted () {
      return this.getStepIsCompleted('customersCompleted')
    },

    isCustomersEmpty () {
      return !this.customers.length
    },

    customersToShowGrid () {
      if (this.searchValue !== '' && this.searchValue) {
        return this.filterCustomers
      }

      return this.showAllCustomersGrid === true
        ? this.customers
        : this.customers.slice(0, 3)
    },

    customersToShowList () {
      if (this.searchValue !== '' && this.searchValue) {
        return this.filterCustomers
      }

      return this.showAllCustomersList === true
        ? this.customers
        : this.customers.slice(0, 7)
    },

    filterCustomers () {
      return this.customers.filter(item => item.name.toUpperCase().includes(this.searchValue.toUpperCase()))
    },

    hasNotAccess () {
      return !this.canEdit || this.statusOfCompleted
    },

    removeButtonVisible () {
      return this.canEdit && this.getHasItemsFromTemplate('getCustomers')
    },

    backNavigation () {
      return {
        title: this.$t('pages.businessGuide.navigation.market'),
        route: 'business-guide-research-market'
      }
    },

    nextNavigation () {
      return {
        title: this.$t('pages.businessGuide.navigation.competitors'),
        route: 'business-guide-research-competitors'
      }
    }
  },

  async created () {
    await this.openGuide('customerGuide')
    await this.getCustomers()
    this.$store.commit('ui/setLoader', { key: 'aiTemplate', value: false })
  },

  methods: {
    ...mapActions('idea', [
      'getCustomers',
      'deleteStoryModeCustomers',
      'deleteIdeaExamples',
      'updateOrderNumber'
    ]),

    onStartCustomersOrder () {
      this.$refs.actionsDropdown.forEach(dropdown => {
        dropdown.$refs.itemDropdown.visible = false
      })
    },

    onChangeCustomersOrder (data) {
      this.updateOrderNumber({
        type: 'customers',
        data,
        oldOrderData: this.customers,
        mutation: 'setCustomers'
      })
    },

    checkCustomersCard (customer) {
      if (!this.canEdit) return
      if (this.statusOfCompleted) {
        this.dialogProcessCompletedVisible = true

        return
      }
      if (customer.id) {
        this.onEditCustomer(customer)
      }
    },

    onCloseDialogAddCustomer () {
      this.dialogAddCustomerVisible = false
      this.customerAction = null

      // Workaround to update computed property customersToShowGrid & customersToShowList
      this.updateCustomersView()
    },

    onEraseFromTemplate () {
      if (this.statusOfCompleted) {
        this.openedDialogProcessCompleted()

        return
      }
      this.dialogRemoveExamplesVisible = true
    },

    updateCustomersView () {
      this.showAllCustomersList = !this.showAllCustomersList
      this.showAllCustomersList = !this.showAllCustomersList
      this.showAllCustomersGrid = !this.showAllCustomersGrid
      this.showAllCustomersGrid = !this.showAllCustomersGrid
    },

    onAddCustomer () {
      if (!this.canEdit) return
      this.dialogAddCustomerVisible = true
    },

    onEditCustomer (customer) {
      this.customerAction = Object.assign({}, customer)
      this.dialogAddCustomerVisible = true
    },

    onCopyCustomer (customer) {
      this.customerAction = Object.assign({}, customer)
      this.customerAction.id = 0
      this.dialogAddCustomerVisible = true
    },

    onDeleteCustomer (customer) {
      this.deleteStoryModeCustomers(customer.id)

      // Return to grid view, if there are no customers
      // if (this.$store.state.idea.storyMode.research.customers.customers.length === 0) {
      //   this.onActivateView('grid')
      // }
    },

    cardImageBySize (image, size) {
      return image ? 'background-image: url(' + getImageBySize(image.sizes, size) + ')' : ''
    },

    onGuideExampleVisible () {
      this.guideVisible = !this.guideVisible
    },

    onActivateView (view) {
      this.$store.commit('itemsView/setCustomersView', view)
    },

    getCustomerLevel (customer) {
      // noinspection JSUnresolvedVariable
      const attributesLevel = customer.segmentSize + customer.willingnessToPay + customer.accessibility

      if (attributesLevel <= 5) {
        return this.$t('low')
      } else if (attributesLevel <= 10) {
        return this.$t('medium')
      }

      return this.$t('high')
    },

    deleteExamples () {
      this.removeExamplesLoading = true
      this.deleteIdeaExamples('customers')
        .then(response => {
          const { type, ids } = response
          this.deleteFromState({ type, ids })
          this.dialogRemoveExamplesVisible = false
          this.removeExamplesLoading = false
        }).catch(_ => { this.removeExamplesLoading = false })
    }
  }
}
</script>

<style scoped>
  #story-mode-customers {
    margin-left: 0;
  }
</style>
